export default "__VITE_ASSET__ee803264__"